import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ItemSelect from "../../shared/Input/ItemSelect";
import {Selector_Locations_Listing_Root} from "../../../store/selectors/Selectors_Location";
import {Thunk_Locations_Fetch_All} from "../../../store/thunk/Thunk_Location";

class LocationSelect extends React.Component {
	render() {
		const {Thunk_Locations_Fetch_All} = this.props;

		return <ItemSelect
			thunk={Thunk_Locations_Fetch_All}
			selector={Selector_Locations_Listing_Root}
			label={"location_select"}
			headerItems={{name: {}, id: {}}}
			{...this.props}
		/>
	}

	static get propTypes() {
		return ItemSelect.propTypes
	}
}

const mapDispatchToProps = dispatch => (
	bindActionCreators({
		Thunk_Locations_Fetch_All
	}, dispatch)
);

export default connect(null, mapDispatchToProps)(LocationSelect);
